import { render, staticRenderFns } from "./rcxc.vue?vue&type=template&id=1036cb95&scoped=true&"
import script from "./rcxc.vue?vue&type=script&lang=js&"
export * from "./rcxc.vue?vue&type=script&lang=js&"
import style0 from "./rcxc.vue?vue&type=style&index=0&id=1036cb95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036cb95",
  null
  
)

export default component.exports